import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import './phoneNumber.css';
import Button from '@components/common/Button';
import InputFieldsComponent from '@components/common/InputFieldsSmall';
import endpoints from '@config/endpoints';
import { getData, postDataJSON } from '../../../../services/CommonApiService';
import { getUserConsentLanguage } from '@services/childApiServices';
import { Spinner } from 'react-bootstrap';
import InfoBar from '@components/common/InfoBars';
import { beneficiariesInRCH, beneficiaryAlreadyInRCH, setBeneficiaryData, setBeneficiaryMobileNumber, setTsnID, setConsentLanguage } from '@store/actions/beneficiaryAction';
import { encode, decode, encodeWithKeyAndShift, decryptData, decodeWithKeyAndShift } from '../../../../utils/base64Utils';
import { useDispatch } from 'react-redux';
import { errorLogger } from '@utils/applicationLogUtils';
import { isValueContainsOnlyDigits } from '@utils/hrpConditionCheck';
import { RootState } from '@store/reducers';
import { sanitizeName } from '@utils/childUtils';
import { useSelector } from 'react-redux';
import CheckboxComponent from '@components/common/CheckBox';
import { toast } from 'react-toastify';
import { benef_const, benef_error_const } from '@constants/beneficiaryConstant';
import { errorMessage } from '@constants/errSuccConstant';
import { useOtpCooldown, isOtpRateLimited, isOtpRateLimitedError } from '@hooks/useOtpCooldown';
import { otpCooldownMessage } from '@constants/appConstants';


interface showModalProps {
    handleClose: (authType: string) => void;
    setLinkedBenefDetails:Dispatch<SetStateAction<string>>;
};

const VerificationPhoneNumber = ({ handleClose, setLinkedBenefDetails }: showModalProps) => {
    const beneficiary = useSelector((state: RootState) => state.beneficiary);
    const [phoneNumberErrorMessage, setPhoneNumberErrorMessage] = useState<string>('');
    const [inputPhoneNumber, setInputPhoneNumber] = useState<string>('');
    const [isPhoneNumber, setIsPhoneNumberError] = useState<boolean>(false);
    const [showSpinner, setSHowSpinner] = useState<boolean>(false);
    const [errormsg, setErrorMsg] = useState<string>('');
    const [dataError, setDataError] = useState<boolean>(false);
    const [mobError, setMobError] = useState<boolean>(false);
    const dispatch = useDispatch()
    const [name, setName] = useState<string>('');
    const [nameErrorMessage, setNameErrorMessage] = useState<string>('');
    const [isNameError, setIsNameError] = useState<boolean>(false);
    const [consentCheckbox, setConsentCheckbox] = useState<boolean>(false);
    const [consentShow, setConsentShow] = useState<boolean>(false);
    const [checkedState, setCheckedState] = useState<boolean[]>([]);
    const [consentLanguageData, setConsentLanguageData] = useState<any>([]);
    const userDetail = JSON.parse(decodeWithKeyAndShift(localStorage.getItem('userDetails')));
    // Keeps the cooldown tied to the submitted number even after the field is cleared.
    const [cooldownMobile, setCooldownMobile] = useState<string>('');
    const { secondsLeft, isCoolingDown, startCooldown } = useOtpCooldown(inputPhoneNumber || cooldownMobile);
    const isAllChecked = checkedState?.every((checked) => checked);

    useEffect(() => {
            getConsentLanguage();
        }, []);

        const createErrorMessage = (abdmMessage: string, rchMessage?: string) => (
                  <div>
                      <p><strong>ABDM:</strong> {abdmMessage}</p>
                      {rchMessage && <p><strong>JANANI:</strong> {rchMessage}</p>}
                  </div>
              );
          
              const handleError = (message: string, rchMessage?: string) => {
                  const errorMessage = createErrorMessage(message, rchMessage);
                  toast.error(errorMessage, {
                      position: "top-center",
                  });
                  setSHowSpinner(false);
              };
    
        const getConsentLanguage = async () => {
            try {
                const type = "Beneficiary"
                const consent = "phone_number"
                const response = await getUserConsentLanguage(type, consent);
                setConsentLanguageData(response);
                const res: any = response?.data[0]?.length // 6
                setCheckedState(new Array(res).fill(false))
            } catch (error: any) {
                errorLogger(error?.response?.data || error?.response || error)
            }
        };


    const handleFormChangePhoneNumber = (event: any) => {
        const isValue = isValueContainsOnlyDigits(event);
        setIsPhoneNumberError(false);
        setPhoneNumberErrorMessage('');
        if (isValue) {
            setInputPhoneNumber(event);
        } else if (event.length === 0) {
            setInputPhoneNumber("");
        }
    };

    const formatNumber = (num: string): string => {
        // Split the number into parts
        const part1 = num.slice(0, 2);
        const part2 = num.slice(2, 6);
        const part3 = num.slice(6, 10);
        const part4 = num.slice(10);

        // Join the parts with hyphens
        return `${part1}${part2}${part3}${part4}`;
    };

    const handleSavePhoneNumber = async () => {
        let tempError = false;
        if (!name.trim()) {
            setNameErrorMessage(errorMessage.NAME_ERROR);
            setIsNameError(true);
            tempError = true;
        } else {
            setNameErrorMessage('');
            setIsNameError(false);
        }
        if (!/^\d+$/.test(inputPhoneNumber)) {
            setPhoneNumberErrorMessage(errorMessage.INVALID_PHONE);
            tempError = true
        }
        if (inputPhoneNumber.length !== 10) {
            setPhoneNumberErrorMessage(errorMessage.INVALID_DIGITS)
            tempError = true
        }
        setIsPhoneNumberError(tempError);
        if (tempError) {
            return;
        }
        if (isCoolingDown) {
            handleError(otpCooldownMessage);
            return;
        }
        setCooldownMobile(inputPhoneNumber);
        const formattedNum = formatNumber(inputPhoneNumber);
        const data = {
            "mobile": formattedNum
        }
        setIsPhoneNumberError(false);
        try {
            setDataError(false);
            setMobError(false)
            setSHowSpinner(true);
            
            if (beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.face_Authentication) {
                try {
                    const searchPayload = {
                        "scope": ["search-abha"],
                        "mobile": formattedNum
                    };
                    const searchResponse = await postDataJSON<any>(`${endpoints.faceAuthAbhaSearch}`, searchPayload);
                    
                    setSHowSpinner(false);
                    
                    const responseData = searchResponse.data?.data || searchResponse.data;
                    
                    if (responseData && responseData[0]?.ABHA && responseData[0].ABHA.length > 0) {
                        const txnId = responseData[0].txnId;
                        const abhaAccounts = responseData[0].ABHA;
                        
                        const beneficiaryData = abhaAccounts.map((account: any) => ({
                            name: account.name,
                            abhaId: account.ABHANumber.replace(/-/g, ''),
                            gender: account.gender,
                            dob: '',
                            address: '',
                            profile: '',
                            mob: formattedNum,
                            kycVerified: account.kycVerified,
                            index: account.index
                        }));
                        
                        dispatch(setBeneficiaryData(beneficiaryData));
                        dispatch(setTsnID(txnId));
                        dispatch(setBeneficiaryMobileNumber(formattedNum));
                        dispatch(beneficiaryAlreadyInRCH(false));
                        setInputPhoneNumber('');
                        handleClose('face-auth-complete');
                    } else {
                        handleError('No ABHA accounts found for this mobile number.');
                    }
                } catch (error: any) {
                    setSHowSpinner(false);
                    handleError('Failed to search ABHA accounts. Please try again.');
                    errorLogger(error?.response?.data || error?.response || error);
                }
                return;
            }
            
            const mobData={
                mobileNumber:formattedNum
            }
            const encodedData = encodeWithKeyAndShift(JSON.stringify(mobData));
            const mobNumCheckResponse = await postDataJSON<any>(`${endpoints.checkBenefMobileNumberExists}`, {data:encodedData});
            const decodedResponse= JSON.parse(decodeWithKeyAndShift( mobNumCheckResponse.data.data));
            dispatch(beneficiariesInRCH(decodedResponse.benefDetails))
            if (decodedResponse.isBenefExist === false) {
                dispatch(beneficiaryAlreadyInRCH(false))
                try {
                    const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
                    const response = await postDataJSON<any>(`${endpoints.verifyAbhaByMobileNumberSendOtp}`, { data: encodedPayload });
                    const decodedData = JSON.parse(decodeWithKeyAndShift(response.data));
                    setSHowSpinner(false);
                    if (decodedData?.txnId) {
                        const consentDetails = [
                            ...consentLanguageData.data[0].map((item :any)=> ({
                                consent_template_id: item.consent_template_id,
                                conscent_template_content: item?.consent_template_content.includes('{#var1#}')
                                ? item?.consent_template_content.replace(
                                '{#var1#}',
                                `${userDetail.first_name || ''} ${userDetail.last_name || ''}`
                                ):
                                item?.consent_template_content?.includes('{#name#}')?
                                item?.consent_template_content.replace(
                                '{#name#}',
                                `${name || ''}`
                                )
                            : item?.consent_template_content
                            })),
                            ];
                        dispatch(setConsentLanguage(consentDetails));
                        dispatch(setTsnID(decodedData.txnId))
                        setInputPhoneNumber('');
                        dispatch(setBeneficiaryMobileNumber(`${decodedData.message} ${formattedNum}`));
                        dispatch(beneficiaryAlreadyInRCH(false))
                        handleClose('submit');
                        dispatch(beneficiaryAlreadyInRCH(false))
                        setIsPhoneNumberError(false);
                        setDataError(false);
                        setMobError(false)
                    }
                    else if (decodedData?.message?.includes('does not match')) {
                        handleError(`${decodedData?.code} - ${decodedData.message}`, benef_error_const?.provideCorrectPhone);
                    } 
                    else if (decodedData?.message?.includes('30 seconds')) {
                        // startCooldown();
                        handleError(decodedData.message);
                    } 
                    else if (decodedData?.message?.includes('multiple OTPs')) {
                        handleError(decodedData.message, benef_error_const?.multipleOTP);
                    } 
                    else if (decodedData?.message?.includes('Missing Credentials')) {
                        handleError(`${decodedData?.code} - ${decodedData.description}`);
                    }
                    else if(decodedData?.message?.includes('Too many request attempted')){
                        handleError(`${decodedData?.message}`);
                    }
                    else if (decodedData?.message?.includes('Aadhaar Gateway is unavailable')) {
                        handleError(decodedData?.message);
                    }
                    else if (decodedData?.message?.includes('Runtime Error')) {
                        handleError(`${decodedData?.code} - ${decodedData.message}`, benef_error_const?.urlNotFound);
                    }
                    else if(decodedData?.loginId.includes('Invalid LoginId')){
                        handleError(`${decodedData?.loginId}`, benef_error_const?.provideCorrectPhone);
                    }
                    else {
                        handleError(`${decodedData?.message ?? benef_error_const.genericAbdmMessage}`);
                    }
                } catch (error:any) {
                    if (isOtpRateLimitedError(error)) {
                        startCooldown();
                        handleError(otpCooldownMessage);
                        return;
                    }
                    const decodedData = JSON.parse(decodeWithKeyAndShift(error));
                    const res = decodedData;
                    let catchErrorMessage = '';
                    if(res?.message && res?.code){
                        catchErrorMessage =`${res?.code} - ${res?.message}`
                    }else if(res?.message && !res?.code){
                        catchErrorMessage =`${res?.message}`
                    }else if(res?.loginId){
                        catchErrorMessage =`${res?.loginId}`
                    }else if(res?.Aadhaar){
                        catchErrorMessage =`${res?.Aadhaar}`
                    }else{
                        catchErrorMessage = benef_error_const.genericAbdmMessage
                    } 
                    if (isOtpRateLimited(catchErrorMessage)) {
                        startCooldown();
                    }
                    handleError(catchErrorMessage);
                    errorLogger(res, "Phone OTP Generation-verifyAbhaByMobileNumberSendOtp");   
                }
            }
            else {
                setLinkedBenefDetails(decodedResponse.benefDetails)
                dispatch(setBeneficiaryMobileNumber(`${inputPhoneNumber}`));
                dispatch(beneficiaryAlreadyInRCH(true))
                setSHowSpinner(false);
                handleClose('show-exist-modal');
            }
        }
        catch (error: any) {
            setSHowSpinner(false);
            handleError(benef_error_const.unableToGenerateOtp);
            errorLogger(error?.response?.data || error?.response || error)
        }
    }

    const handleNameChange = (event: any) => {
         const sanitizedValue = sanitizeName(event);
        setName(sanitizedValue);
        if(sanitizedValue.length === 0) {
            setConsentCheckbox(false);
        }
    }

    const showConsentForm = () => {
        if (consentLanguageData?.length === 0) {
            toast.error("Unable to fetch consent details. Please try again later.", {
                position: "top-center",
            });
            getConsentLanguage();
            return;
        }
        setConsentShow(true);
    };

    const handleCheckboxChange = (index: number, checked: boolean) => {
            const updatedCheckedState = [...checkedState];
            updatedCheckedState[index] = checked;
            setCheckedState(updatedCheckedState);
          };
         
          const handleSelectAll = (checked: boolean) => {
            setCheckedState(new Array(checkedState?.length).fill(checked));
          };

          const handletoPhoneNumber = () => {
            setConsentCheckbox(true);
            setConsentShow(false);
          };

    return (
        <>
            {
                !consentShow &&
                <div className='PhoneNumberContainer'>
                    {<div className='PhoneNumberIdContainer'>
                        <h4 className='PhoneNumberHeadings'>Register with Phone Number </h4>
                        <div className='PhoneNumberInputFields'>
                            <InputFieldsComponent
                                labelName="Enter Phone Number"
                                placeholder={"Type Here"}
                                type={'text'}
                                isDisabled={false}
                                onChange={handleFormChangePhoneNumber}
                                errorMessage={phoneNumberErrorMessage}
                                value={inputPhoneNumber ? inputPhoneNumber : ''}
                                maximumLength={10}
                                inputType={isPhoneNumber ? 'error' : 'general'}
                                required={true} />
                        </div>
                    </div>}
                    <div className="input_field_infoBars">
                        {dataError && (
                            <InfoBar
                                variant="danger"
                                message={errormsg}
                                className="input_field_class"
                            />
                        )}
                        {mobError && (
                            <InfoBar
                                variant="danger"
                                message={errorMessage.ALREADY_LINKED}
                                className="input_field_class"
                            />
                        )}
                    </div>
                    <InputFieldsComponent
                        labelName="Enter Full Name"
                        placeholder={'Type Here'}
                        type={'text'}
                        isDisabled={false}
                        onChange={handleNameChange}
                        errorMessage={nameErrorMessage}
                        inputType={isNameError ? 'error' : 'general'}
                        value={name}
                        required={true}
                    />
                    <div className="aadhar_checkbox">
                        <CheckboxComponent
                            className="align-item_check_box"
                            checkBoxName=""
                            disabled={false}
                            onCheckboxChange={() => { }}
                            placeCheckboxBefore={false}
                            isChecked={consentCheckbox}
                        />
                        <p>
                            I hearby confirm that I agree to the {' '}
                            <button
                                onClick={showConsentForm}
                                className="aadhar_consent_form"
                            disabled={ !inputPhoneNumber.length || !name.length}
                            >
                                Consent Process
                            </button>{' '}
                            for the verification of ABHA and linking with JANANI programme/application
                        </p>
                    </div>
                    <span>{showSpinner && (<><span>Loading...</span><Spinner /></>)} </span>
                    <div className='PhoneNumberSubmit'>
                        {isCoolingDown && (
                            <p style={{ color: '#b42318', fontSize: '12px', margin: '8px 0 0' }}>
                                You can request for new OTP after {secondsLeft} seconds
                            </p>
                        )}
                        <Button
                            onClick={handleSavePhoneNumber}
                            disabled={isCoolingDown ? true : inputPhoneNumber?.length>0 && name?.length>0 && consentCheckbox ? false : true}
                            id="PhoneNumberBeneficiarySubmit"
                            buttonName={'Submit'}
                            colorType={'primary'}
                        />
                    </div>
                </div>
            }
            {consentShow && (
                <div className="aadhar_consent_form_enlarge">
                    <h1 className="aadhar_headings">Consent Process</h1>
                    <div className="consent_form_for_aadhar">
                        I hereby declare that:
                        {/* Select All Checkbox */}
                        <CheckboxComponent
                            isChecked={isAllChecked}
                            onCheckboxChange={handleSelectAll}
                            disabled={false}
                            className="consent-select-all"
                            checkBoxName="Select All"
                        />
                        {/* Individual Checkboxes */}
                        {consentLanguageData?.data[0]?.map((item: any, index: any) => (
                            <CheckboxComponent
                                key={index}
                                isChecked={checkedState?.[index]}
                                onCheckboxChange={(checked) =>
                                    handleCheckboxChange(index, checked)
                                }
                                disabled={false}
                                className={`consent-checkbox-item`}
                                checkBoxName={
                                    item?.consent_template_content.includes('{#var1#}')
                                        ? item?.consent_template_content.replace(
                                        '{#var1#}',
                                        `${userDetail.first_name || ''} ${userDetail.last_name || ''}`
                                        ):
                                        item?.consent_template_content?.includes('{#name#}')?
                                        item?.consent_template_content.replace(
                                        '{#name#}',
                                        `${name || ''}`
                                        )
                                    : item?.consent_template_content
                                }
                            />
                        ))}
                    </div>
                    <div className="aadhar-submit">
                        <Button
                            onClick={handletoPhoneNumber}
                            disabled={isAllChecked ? false : true}
                            id="aadhar-beneficiary-submit"
                            buttonName={'Submit'}
                            colorType={'primary'}
                            icon={''}
                            iconPosition={''}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default VerificationPhoneNumber;